import * as ordersConstant from './constants'
const initialState = {
  list: [],
  item: {},
  type: ordersConstant.PROCESS_ORDERS_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  ordersApproveChecked: [],
  formData: {},
  processMessages: [],
  processErrors: [],
  callback: () => { }
}
const reducer = function processOrdersReducer(state = initialState, action) {
  switch (action.type) {
    case ordersConstant.PROCESS_ORDERS_LIST_NV_REQUESTING:
      return {
        ...state,
        list: [],
        item: {},
        type: action.type,
        messages: [],
        errors: [],
      }
    case ordersConstant.PROCESS_ORDERS_CREATE_ORDER_REQUESTING:
      return {
        ...state,
        list: [],
        item: {},
        type: action.type,
        messages: [],
        errors: [],
      }
    case ordersConstant.PROCESS_ORDERS_APPROVE_SET_LIST:
      return {
        ...state,
        ordersApproveChecked: action.payload,
      }
    case ordersConstant.PROCESS_ORDERS_APPROVE_LIST_REQUESTING:
      return {
        ...state,
        formData: action.payload,
        callback: action.callback,
        processMessages: [],
        processErrors: [],
      }

    case ordersConstant.PROCESS_ORDERS_SET_APPROVE_MESSAGE:
      let processMessages = []
      if (action.payload != "") {
        processMessages = [{
          body: action.payload,
          time: new Date(),
        }]
      }
      return {
        ...state,
        errors: [],
        messages: [{
          body: action.payload,
          time: new Date(),
        }],
      }
    case ordersConstant.PROCESS_ORDERS_SET_APPROVE_ERROR:
      return {
        ...state,
        messages: [],
        errors: [{
          body: action.payload,
          time: new Date().getTime(),
        }],
      }
    case ordersConstant.PROCESS_ORDERS_LIST_NV_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data,
        messages: [],
        errors: [],
      }

    case ordersConstant.PROCESS_ORDERS_LIST_NV_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case ordersConstant.PROCESS_ORDERS_LIST_REQUESTING:
      return {
        ...state,
        list: [],
        item: {},
        type: action.type,
        listRequesting: true,
        messages: [],
        errors: [],
        formData: {},
        callback: () => { },
      }

    case ordersConstant.PROCESS_ORDERS_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data.records,
        item: action.data,
        listRequesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case ordersConstant.PROCESS_ORDERS_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case ordersConstant.PROCESS_ORDERS_SET_IS_LOADING:
      return {
        ...state,
        requesting: action.payload
      }
    case ordersConstant.PROCESS_ORDERS_LOAD_ORDER_DETAILS:
      return {
        ...state,
        messages: [],
        errors: []
      }
    case ordersConstant.PROCESS_ORDERS_CHECKED_LIST_REQUESTING:
      return {
        ...state,
        messages: [],
        errors: []
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/ProcessOrders/reducer.js